<script setup lang="ts">
import CheckIcon from '@/components/icons/CheckIcon.vue'
import type { SelectMenuItem } from '@/partners/lingo/lingo-giveaway/types/common'
import { twMerge } from 'tailwind-merge'
import { ref } from 'vue'
import ArrowDown from '@/components/icons/ArrowDown.vue'

defineProps<{
  placeholder?: string
  label?: string,
  menuItems: SelectMenuItem[]
}>()

const selectedMenuItem = defineModel<SelectMenuItem | undefined>()
const isOpen = ref<boolean>(false)

function applyShow() {
  if (!isOpen.value) {
    isOpen.value = true
  }
}

function applyHide() {
  isOpen.value = false
}

function onSelect(item: SelectMenuItem) {
  selectedMenuItem.value = item
  setTimeout(() => {
    applyHide()
  }, 200)
}
</script>

<template>
  <div class="flex flex-col gap-y-3 w-full">
    <p
      v-if="label"
      class="text-base font-semibold text-light-white/[70%]"
    >
      {{ label }}
    </p>
    <VDropdown
      :distance="6"
      :shown="isOpen"
      popper-class="select-popover w-full"
      @apply-show="applyShow"
      @hide="applyHide"
    >
      <button
        @click.prevent="isOpen = !isOpen"
        class="flex justify-between w-full py-[18px] px-4 bg-dark-top-layer rounded-xl"
      >
        <span
          class="flex flex-1 text-base font-semibold"
          :class="{'': !!selectedMenuItem}"
        >
          <span
            v-if="selectedMenuItem"
            class="text-white/[87%]"
          >
            {{ selectedMenuItem.text }}
          </span>
          <span
            v-else
            class="text-white/[38%]"
          >{{ placeholder }}</span>
        </span>
        <span
          class="ml-auto"
        >
          <ArrowDown
            :class="twMerge('', isOpen && 'rotate-180')"
          />
        </span>
      </button>

      <template #popper>
        <div
          v-if="isOpen"
          class="w-full flex h-full overflow-hidden"
        >
          <div class="cursor-pointer w-full overflow-y-auto h-full max-h-[200px] flex flex-col">
            <ul>
              <li
                v-for="(item, index) in menuItems"
                :key="index"
                class="py-2 px-4 cursor-pointer flex justify-between items-center"
                @click="onSelect(item)"
              >
                <span
                  class="flex-1 truncate text-base font-semibold text-white/[87%]"
                >
                  {{ item.text }}
                </span>
                <div
                  class="menu-item-trailing-icon-container"
                >
                  <CheckIcon
                    class="size-4 text-white/[87%]"
                    v-if="item.key === selectedMenuItem?.key"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>
    </VDropdown>
  </div>
</template>
<style lang="scss">
.select-popover {
  @apply px-6 #{!important};
  &.v-popper--theme-dropdown {
    .v-popper__inner {
      @apply m-0 rounded-xl shadow-[0_0_12px_rgba(29,29,27,0.16)] filter-none max-w-none bg-dark-top-layer #{!important};
    }
  }

}

</style>